import React from 'react'

import { useNavigation } from '@react-navigation/native'
import { B2, SH2, SH3, Stack, XStack } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import ArrowRight from '@zet/design-system/svg/ArrowRight'
import QuestionMarkOutlined from '@zet/design-system/svg/QuestionMarkOutlined'

import { i18n } from '../../localization'

const HelpAndSupport = () => {
  const { navigate } = useNavigation()

  const handlePress = () => {
    navigate('Faqs')
  }
  return (
    <Stack className="border-grays-30 border-b border-t-2 px-3 py-3">
      <SH2>{i18n.t('helpAndSupport.heading')}</SH2>
      <Pressable className="mt-3" onPress={handlePress}>
        <XStack className="items-center">
          <XStack className="flex-1 flex-row items-center">
            <QuestionMarkOutlined />
            <Stack className="ml-2">
              <SH3>{i18n.t('helpAndSupport.faqs')}</SH3>
              <B2>{i18n.t('helpAndSupport.faqsSubtitle')}</B2>
            </Stack>
          </XStack>
          <Stack className="items-end">
            <ArrowRight />
          </Stack>
        </XStack>
      </Pressable>
    </Stack>
  )
}

export default HelpAndSupport
